export default __webpack_public_path__ + "d4b27f941e7bd06876679eb6217d97f3.png";